<div class="package-header">
  <div class="setting">
    <div class="h7">Packages</div>
    <p class="p5">View and manage car wash packages</p>
  </div>
  <div class="package-header-actions">
    <button
      type="button"
      class="btn btn-medium package-header-actions__configure"
      (click)="openConfigureSalesPanel()"
      title="Sort packages, most used services, and sales display order"
    >
      Configure Sales Panel
    </button>
    <button class="btn btn-primary btn-medium" (click)="openModal()">
      <img src="assets/images/package/plus.svg" alt="Add Package" />
      Add Package
    </button>
  </div>
</div>
<app-tab-view
  [tabs]="packagePageTabs"
  [defaultActiveTab]="activePageTab"
  (tabChange)="onPackagePageTabChange($event)"
>
  <div class="package-tab-content">
    @if (activePageTab === 'Packages') {
      <div class="package-cards-container">
        <app-package-cards
          [title]="'Total Packages'"
          [count]="totalPackagesCount"
          [cardClass]="'card-1'"
          [image]="packageImage"
        ></app-package-cards>
        <app-package-cards
          [title]="'Active Packages'"
          [count]="activePackagesCount"
          [cardClass]="'card-2'"
          [image]="packageImage2"
        ></app-package-cards>
        <app-package-cards
          [title]="'Inactive Packages'"
          [count]="inactivePackagesCount"
          [cardClass]="'card-3'"
          [image]="packageImage3"
        ></app-package-cards>
      </div>
      <app-package-filters
        (viewChanged)="onViewChanged($event)"
        (filtersApplied)="onFiltersApplied($event)"
        (tableSorted)="onTableSorted($event)"
        (searchChanged)="onSearchChanged($event)"
        (openConfigureSortPanel)="openConfigureSalesPanel()"
      ></app-package-filters>
      @if ((packagesLoading$ | async) === false) {
        @if (packages.length > 0) {
          <div class="package-content">
            @if (currentView === 'grid') {
              <app-package-grid
                [packages]="packages"
                (edit)="openModal($event)"
                (delete)="openDeleteModal($event)"
                (duplicate)="duplicatePackage($event)"
              ></app-package-grid>
            }
            @if (showPackageTable) {
              <app-package-table
                [packages]="packages"
                (edit)="openModal($event)"
                (delete)="openDeleteModal($event)"
                (duplicate)="duplicatePackage($event)"
                (tableFiltering)="onTableFiltering($event)"
              ></app-package-table>
            }
          </div>
        }
      } @else {
        <div class="package-content package-content--shimmer">
          <app-loading-table-shimmer
            [columns]="packageListShimmerColumns"
            [rows]="8"
            [showHeader]="true"
            className="package-list-shimmer"
          >
          </app-loading-table-shimmer>
        </div>
      }

      @if (packages.length === 0 && (packagesLoading$ | async) === false) {
        <app-empty-state
          testId="packages-empty-state"
          variant="card"
          image="assets/images/package/Illustrations.svg"
          imageAlt="No Packages"
          actionIcon="assets/images/package/plus.svg"
          [title]="emptyStateConfig.title"
          [description]="emptyStateConfig.description"
          actionLabel="Add Package"
          [showAction]="emptyStateConfig.showAddButton"
          (action)="openModal()"
        >
        </app-empty-state>
      }
    }
    @if (activePageTab === 'Prepaid Wash Books') {
      <app-prepaid-wash-books #prepaidWashBooks (edit)="openEditPrepaidModal($event)" />
    }
  </div>
</app-tab-view>

@if (showPackageTypeModal) {
  <div
    class="package-type-overlay"
    role="dialog"
    aria-modal="true"
    aria-labelledby="package-type-modal-title"
    tabindex="0"
    (click)="onPackageTypeOverlayClick($event)"
    (keydown.escape)="closePackageTypeModal()"
  >
    <div class="package-type-modal">
      <div class="package-type-modal__header">
        <h2 class="package-type-modal__title" id="package-type-modal-title">Select a package</h2>
        <button
          type="button"
          class="package-type-modal__close"
          (click)="closePackageTypeModal()"
          aria-label="Close"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1L1 13M1 1L13 13"
              stroke="#555963"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      <form (ngSubmit)="onPackageTypeContinue()">
        <div class="package-type-modal__body">
          <label
            class="package-type-option"
            [class.package-type-option--selected]="selectedPackageKind === 'package'"
          >
            <input
              type="radio"
              name="package_kind"
              value="package"
              [(ngModel)]="selectedPackageKind"
            />
            <span class="package-type-option__label">Package</span>
          </label>
          <label
            class="package-type-option"
            [class.package-type-option--selected]="selectedPackageKind === 'prepaid_plan'"
          >
            <input
              type="radio"
              name="package_kind"
              value="prepaid_plan"
              [(ngModel)]="selectedPackageKind"
            />
            <span class="package-type-option__label">Prepaid</span>
          </label>
        </div>

        <app-modal-footer-actions
          footerClass="modal-footer"
          [showSecondary]="false"
          primaryText="Continue"
          primaryButtonType="submit"
          [stackOnMobile]="true"
          (cancelClick)="closePackageTypeModal()"
        />
      </form>
    </div>
  </div>
}

@if (showPrepaidModal) {
  <app-add-prepaid-modal
    [prepaidData]="prepaidEditData"
    [prepaidBookId]="prepaidEditBookId"
    (closed)="closePrepaidPackageModal()"
    (saved)="onPrepaidSaved($event)"
  />
}

@if (showModal) {
  <app-add-package-modal
    (close)="closeModal()"
    [packageData]="selectedPackage"
  ></app-add-package-modal>
}
@if (showDeleteModal) {
  <app-delete-package-modal
    (close)="closeDeleteModal()"
    (confirm)="deletePackage($event)"
    [package]="packageToDelete"
  ></app-delete-package-modal>
}

<app-filter-modal
  [isVisible]="isConfigureFilterModalVisible"
  [categories]="configureFilterCategories"
  header="Configure Sales Panel"
  customClass="filter-modal--configure-sales"
  primaryButtonText="Apply Filters"
  secondaryButtonText="Clear Filters"
  [isLoading]="isConfigureSortOptionsLoading"
  [showMostUsedServices]="false"
  mostUsedServicesButtonText="Most used services"
  [triggerMostUsedOnOptionValue]="'custom-drag-drop'"
  [sortPanelLocations]="configureSalesLocations"
  [sortPanelSelectedLocationId]="configureSalesLocationId"
  [showRewashSettings]="true"
  [showFamilyPlanSettings]="familyPlanFeatureOn"
  (sortPanelSelectedLocationIdChange)="onConfigureSalesLocationChange($event)"
  (close)="closeConfigureFilterModal()"
  (apply)="onConfigureFiltersApplied($event)"
  (clear)="onConfigureFiltersCleared()"
  (customSortAction)="onConfigureCustomSortAction($event)"
  (mostUsedServicesDefaults)="onConfigureMostUsedDefaults()"
  (mostUsedServices)="onConfigureMostUsedFromFilter()"
>
</app-filter-modal>

<app-most-used-services-modal
  [isOpen]="showMostUsedServicesModal"
  [mode]="mostUsedModalMode"
  [locationId]="mostUsedLocationId"
  [sortOrderId]="mostUsedSortOrderId"
  (close)="onCloseMostUsedServicesModal()"
  (saved)="onMostUsedServicesSaved()"
>
</app-most-used-services-modal>
